import { layout2 } from "../../../../utils/styles";
import React from "react";

export const GroupTitle = ({title, lessonsEmpty}) => {
  return <h2 className={'lsnGroupTitle'} style={lessonsEmpty ? {margin: '10px 0 5px'} : {}}>{title}</h2>
};
